<template>   
    <div class="request_changesec" v-if="!serviceRequest"> 
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-12">  
                    <div class="compose_mailsec">
                        <app-profile :ticketFilter="ticketReasonList[loadServiceRequest]"  :ticketRequest="ticketRequestFrom" :accountIdFrom="account_id" ></app-profile>
                    </div>                   
                </div> 
            </div> 
        </div>
    <div class="whiteBG chatbox right-chatBlock w-100" v-else>
        <loader v-if="pageLoader"></loader>
        <div id="major_service_sec" class="outer_major_sersec">
            <ul class="inner_dropdown request_lisec mb-5" id="myUL" v-if="ticketReasonList != ''">  
                <li v-for="list in ticketData[-1]" v-if="parseInt(ticketReasonList[list].status) == 1 && parseInt(ticketReasonList[list].tickets) == 1 && list != '16'" class="effect-bubba">
                    
                    <a href="javascript:void(0)" v-on:click="enableRequestElement(list)">
                        <div class="icon listWith">
                            <img :src="'../../../../static/website/images/'+iconFile[list].icon" alt="Icon">
                        </div>
                        <figcaption>
                        <h6>{{iconFile[list].lang}}</h6>
                        </figcaption>
                    </a>
                </li>
            </ul>
        </div>
       
    </div> 
</template>
<script>
    import { supportMixins } from '@/plugins/support'
    import profileRequest from './services/profile_request'
    export default {
        name: 'Support & Help Centre',
        mixins: [supportMixins],
        data () {
            return {
                pageTitle : this.$options.name,
                iconFile :{ 
                    '1': {'icon':  'sr_profile.svg','title': "Profile",'lang':'Profile'},
                    '2': {'icon': 'sr_tradingaccount.svg' , 'title': "Exchange",'lang':'Exchange'},
                    '3': {'icon':  'otherTicket.svg' , 'title': "PAMM Requests",'lang':''},
                    '4': {'icon':  'otherTicket.svg' , 'title': "IB Requests",'lang':''},
                    '5': {'icon':  'sr_deposit.svg' , 'title': "Deposits",'lang':'Deposits'},
                    '6': {'icon':  'sr_withdrawals.svg' , 'title': "Withdrawals",'lang':'Withdrawals'},
                    '7': {'icon':  'sr_bonus.svg' , 'title': "Bonus",'lang':''},
                    '8': {'icon':  'sr_vps.svg' , 'title': "VPS",'lang':'VPS'},
                    '9': {'icon':  'sr_reimbursement.svg', 'title': "Reimbursement",'lang':''},
                    '10': {'icon':  'sr_complaints.svg' , 'title': "Complaints",'lang':'Complaints'},
                    '11': {'icon': 'sr_compliance.svg' , 'title': "Compliance",'lang':''},
                    '12': {'icon': 'sr_feedback.svg' , 'title': "Feedback",'lang':'Feedback'},
                    '13': {'icon': 'sr_others.svg' , 'title': "Others",'lang':'Others'},
                    '16': {'icon': 'sr_addpayment.svg', 'title': "Add Payment Method",'lang':'Add payment method'},
                    '91': {'icon': 'otherTicket.svg', 'title': "Registeration Documents",'lang':''},
                    '92': {'icon': 'otherTicket.svg', 'title': "Skip Documents",'lang':''},
                    '94': {'icon': 'otherTicket.svg', 'title': "Become A Pro",'lang':''}
                },
                loadServiceRequest : "",
                serviceRequest : true,
                pageLoader : false,
            }
        },
        components: {
            appProfile: profileRequest
        },
        methods: {
            enableRequestElement(elementName){
                this.loadServiceRequest =  elementName
                if(!parseInt(this.ticketReasonList[this.loadServiceRequest].infomration_req) || (parseInt(this.loadServiceRequest) == 16 && this.method_id != '') || (parseInt(this.loadServiceRequest) == 5 && this.method_id != '')){
                    this.showDiv = '3'
                    if(parseInt(this.loadServiceRequest) == 16){
                        this.chooseRequestType(this.inList_custom_id,this.ticketReasonList[this.loadServiceRequest])
                    }else if(parseInt(this.loadServiceRequest) == 5){
                        this.chooseRequestType(this.inList_custom_id,this.ticketReasonList[this.loadServiceRequest])
                    }else{
                        this.chooseRequestType('',this.ticketReasonList[this.loadServiceRequest])
                    }
                }else{
                    this.showDiv = '1'
                }
                this.serviceRequest = false
            },
            chooseRequestType(getInlistId,getOutListData){
                // console.log(getInlistId)
                // console.log(getOutListData)
                this.reason = getOutListData.id
                this.reason_text = getOutListData.title
                this.title = '0'
                this.title_text = '' 
                if(getInlistId != '' && getInlistId != null){
                    let count = 0;
                    for(var key in  this.ticketReasonList[this.loadServiceRequest].categories){
                        count++
                        if(key == getInlistId){
                            this.title = key
                            this.title_text = this.ticketReasonList[this.loadServiceRequest].categories[key].title
                            this.info_req = this.ticketReasonList[this.loadServiceRequest].categories[key].infomration_req
                        }
                        
                        if(count == Object.keys(this.ticketReasonList[this.loadServiceRequest].categories).length){
                            if(!parseInt(this.info_req)){
                                this.showDiv = '3'
                            }else{
                                this.showDiv = '2'
                            }
                        }
                    }
                }else{
                    this.showDiv = '3'
                }
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/website/supports/help_topic.vue